import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isReviewComplete: false,
  planAmountText: '',
  planFrequencyText: '',
  userComment:'',
  emailsForSubscriptionNotifications: []
};

export const reviewSubscriptionSlice = createSlice({
  name: 'reviewSubscriptionSlice',
  initialState,
  reducers: {
    setPlanAmountText: (state, action) => {
      state.planAmountText = action.payload.planAmount;
    },
    setPlanFrequencyText: (state, action) => {
      state.planFrequencyText = action.payload.planFrequency;
    },
    setReviewComplete: (state, action) => {
      state.isReviewComplete = action.payload.isReviewComplete;
    },
    setUserComment: (state, action) => {
      state.userComment = action.payload.userComment;
    },
    setEmailsForSubscriptionNotifications: (state, action) => {
      state.emailsForSubscriptionNotifications = action.payload.emailsForSubscriptionNotifications;
    }
  }
});

export const {
  setPlanAmountText,
  setPlanFrequencyText,
  setReviewComplete,
  setUserComment,
  setEmailsForSubscriptionNotifications
} = reviewSubscriptionSlice.actions;

export default reviewSubscriptionSlice.reducer;